import * as Yup from 'yup';

const userSchema = Yup.object({
  first_name: Yup.string()
    .label('Etunimi')
    .required(),
  last_name: Yup.string()
    .label('Sukunimi')
    .required(),
  email: Yup.string()
    .label('Sähköpostiosoite')
    .required(),
  role_id: Yup.string()
    .label('Rooli')
    .required(),
  customer_id: Yup.number()
    .nullable()
    .label('Asiakas')
    .when('role_id', {
      is: val => val === 'customer' || val === 'customer-employee',
      then: Yup.number().required(),
      otherwise: Yup.number().oneOf([null])
    }),
  location_id: Yup.number()
    .required('Toimipiste on valittava')
    .label('Toimipiste')
});

export default userSchema;
export type UserSchema = ReturnType<typeof userSchema.cast>;
